export interface CompareChannel {
  id: string;
  name: string;
}

/** Kingpin consumer channels exposed on the compare form (no Retail). */
export const COMPARE_CHANNELS: CompareChannel[] = [
  { id: "82a74ac1-c527-4470-b7b0-fb5f3ef3c2e2", name: "Nike App" },
  { id: "15d92135-394e-487a-8afa-f6c8525c9ea9", name: "WeChat" },
  { id: "d9a5bc42-4b9c-4976-858a-f159cf99c647", name: "Nike.com" },
  { id: "008be467-6c78-4079-94f0-70e2d6cc4003", name: "SNKRS" },
];

export const DEFAULT_COMPARE_CHANNEL_ID = COMPARE_CHANNELS[0]!.id;

const CHANNEL_IDS = new Set(COMPARE_CHANNELS.map((c) => c.id));

export function normalizeCompareChannelId(channelId: string | undefined): string {
  const id = channelId?.trim();
  if (id && CHANNEL_IDS.has(id)) return id;
  return DEFAULT_COMPARE_CHANNEL_ID;
}
